<template>
    <div class="wrap">
        <div class="main">
            <div class="content">
                <div class="frombox">
                    <div class="topbox">
                        <img src="../assets/aotuo/lgicon.png" alt="">
                        <div class="title">
                            <p>欢迎登录</p>
                            <span>xx平台</span>
                        </div>
                    </div>
                    <p><span @click="accountlogin(1)" :class="{ active: isActive === 1 }">账号登录</span><span
                            @click="accountlogin(2)" :class="{ active: isActive === 2 }">手机号登录</span></p>
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
                        <el-form-item prop="username" v-if="isActive === 1" :rules="[
                            { required: true, message: '请输入', trigger: 'blur' },
                        ]">
                            <img src="../assets/aotuo/lgicon1.png" alt="">
                            <el-input v-model="ruleForm.username" placeholder="请输入账号"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" v-if="isActive === 2">
                            <img src="../assets/aotuo/lgicon1.png" alt="">
                            <el-input v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <img src="../assets/aotuo/lgicon2.png" alt="">
                            <el-input v-model="ruleForm.password" placeholder="请输入密码"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">登 录</el-button>
                        </el-form-item>
                    </el-form>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getLogin } from "../api/index";

export default {
    name: 'Login',
    components: {

    },
    data() {
        return {
            isActive: 1,
            ruleForm: {
                username: '',
                phone: '',
                password: '',
            },
            rules: {
                username: [{ required: true, message: '请输入', trigger: 'blur' }],
                phone: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { min: 6, message: '请输入长度不少于6位的密码', trigger: 'blur' }
                ]
            }
        }
    },
    created() {

    },
    mounted() {

    },
    computed: {},
    methods: {
        //账号tab
        accountlogin(i) {
            this.isActive = i;
            this.ruleForm.phone = "";
            this.ruleForm.password = "";
        },
        //手机号tab
        mobilelogin(i) {
            this.isActive = i;
            this.ruleForm.username = ""
            this.ruleForm.password = ""
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    let params = {
                        username: this.ruleForm.username ? this.ruleForm.username : "",//账号登录（选填）
                        mobile: this.ruleForm.phone ? this.ruleForm.phone : "",//手机号登录（选填）
                        password: this.ruleForm.password,//（必填）
                        rememberMe: "false",//（必填）
                        host: this.isActive == 1 ? "globalwebbyname" : "globalwebbtmobile"//（globalwebbyname对应账号，globalwebbtmobile对应手机
                    };
                    getLogin(params).then((res) => {
                        if (res.code == 0) {
                            // localStorage.setItem("login", res.msg);
                            sessionStorage.setItem('login', res.msg);
                            this.$router.push("/home")
                        } else {
                            // console.log(res.msg)
                            this.$message.error(res.msg);
                        }

                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        // submitForm(){
        //     this.$router.push("/home")
        // }
    },
}
</script>
<style lang="less" scoped>
.wrap {
    width: 100%;
    height: 100%;
    background-image: url(../assets/aotuo/loginbg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.main {
    // width: 100%;
    height: 100%;
    display: flex;
    justify-content: right;
    align-items: center;
    padding-right: 200px;
}

.content {
    padding: 60px;
    background: rgba(255, 255, 255, 0.42);
    border-radius: 20px;

    .frombox {
        .topbox {
            display: flex;
            align-items: center;
            margin-bottom: 30px;

            img {
                width: 86px;
                height: 53px;
                margin-right: 16px;
            }

            .title {
                p {
                    margin-bottom: 0;
                    color: #050912;
                    font-size: 28px;
                }

                span {
                    color: #606266;
                    font-size: 18px;
                }
            }
        }

        p {
            font-weight: 600;
            color: #606266;
            ;
            font-size: 20px;
            margin-bottom: 28px;

            span {
                margin-right: 20px;
                display: inline-block;
                padding-bottom: 6px;
                cursor: pointer;
            }

            .active {
                color: #0039c6;
                display: inline-block;
                border-bottom: 2px solid #0039c6;
                padding-bottom: 8px;
            }
        }
    }

}

.el-form-item__content {
    position: relative;

    img {
        width: 14px;
        height: 14px;
        position: absolute;
        z-index: 999;
        top: 13px;
        left: 12px;
    }
}

/deep/.el-input__inner {
    height: 40px;
}

/deep/.el-input {
    input {
        padding: 0 36px;
    }
}

/deep/ .el-button {
    width: 100%;
    height: 40px;
    background: #0039c6;
    font-size: 16px;
}
</style>